import { addLeasedEquipmentStatus } from "actions/Utilities/LeasedEquipmentStatus";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { ILeasedEquipStatus } from "../Types";

export default function useAddLeasedEquipmentStatus() {
  const { mutate } = useMutation(
    (NewData: ILeasedEquipStatus) => addLeasedEquipmentStatus(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Status Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Status Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Status failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Status failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Adding Status failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Adding Status failed", res.Message, "error");
        }
      },

      onError: (error: any) => {
        toast.fire("Add Status failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
